export const ManfrediteDeleteReasonValues = [
    'I_HAVE_ANOTHER_ACCOUNT',
    'INSUFFICIENT_VALUE',
    'BAD_SCOUT_INTERACTIONS',
    'NO_VALUES',
    'FEW_FEATURES',
    'DATA_CONCERNS',
    'OTHER'
];
//# sourceMappingURL=manfredite-delete-reason.js.map